// CONSTANTES ---------------------------------------------------------

const announcementItems = document.querySelectorAll('.announcement-bar__item')
const nbrItems = announcementItems.length

let count = 0

// FUNCTION ---------------------------------------------------------

function displayAnnouncementItem() {
  desactiveAllItems()

  if (count < nbrItems - 1) {
    count++
    announcementItems[count].classList.add('active')
  } else if (count == nbrItems - 1) {
    count = 0
    announcementItems[count].classList.add('active')
  }
}

function desactiveAllItems() {
  for (let pas = 0; pas < nbrItems; pas++) {
    announcementItems[pas].classList.remove('active')
  }
}

// EVENTS ---------------------------------------------------------

announcementItems[0].classList.add('active')

if (statusAutoChange == 'True') {
  setInterval(displayAnnouncementItem, autoChangeInterval)
}
